// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoadingIndicator_container__Q9Hww"};